const arabicMonths = ['كانون الثاني', 'شباط', 'آذار', 'نيسان', 'أيار', 'حزيران', 'تموز', 'آب', 'أيلول', 'تشرين الأول', 'تشرين الثاني', 'كانون الأول'];

const toAr = (num, min = 1) => Number(num).toLocaleString('ar-EG', { minimumIntegerDigits: min, useGrouping: false });

export const formatDate = (dateString) => {
  if (!dateString) return 'غير محدد';

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    let hours = date.getHours();
    const ampm = hours >= 12 ? 'م' : 'ص';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year}\n${hours}:${minutes} ${ampm}`;
  } catch (error) {
    return dateString;
  }
};

export const getTodayDateRange = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const todayStr = `${year}-${month}-${day}`;

  return {
    dateFrom: `${todayStr} 00:00:00`,
    dateTo: `${todayStr} 23:59:59`
  };
};

export const formatDateOnly = (dateString) => {
  if (!dateString) return 'غير محدد';

  try {
    const date = new Date(dateString);
    const day = toAr(date.getDate());
    const month = arabicMonths[date.getMonth()];
    const year = toAr(date.getFullYear());

    return `${day} ${month} ${year}`;
  } catch (error) {
    return dateString;
  }
};



export const formatDateTime = (iso) => {
  if (!iso) return '-';
  try {
    const d = new Date(iso);
    return d.toLocaleString('ar-SY', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return iso;
  }
};
